export enum JET_FM_FEATURE_DATA_TYPES {
  Boolean = 'Boolean',
  Integer = 'Integer',
  String = 'String',
}

export interface IJetFMFeature {
  featureName: string;
  featureDataType: JET_FM_FEATURE_DATA_TYPES;
  valueUntilFMReady?: Boolean | Number | String | null;
}

export const JETFM_FEATURE_HISTORY_DASHBOARD_NEW_TAG: IJetFMFeature = {
  featureName: 'history_dashboard_new_tag',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.String,
};

export const JETFM_FEATURE_LEGACY_THEME_TOGGLER: IJetFMFeature = {
  featureName: 'is_legacy_theme_active',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
  valueUntilFMReady: null,
};

export const JETFM_FEATURE_ANNOUNCEMENT_BANNER_TOGGLER: IJetFMFeature = {
  featureName: 'history_dashboard_announcement',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Integer,
  valueUntilFMReady: -1,
};

export const JETFM_FEATURE_HIDE_HISTORY_DASHBOARD: IJetFMFeature = {
  featureName: 'show_history_dashboard',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};

export const JETFM_FEATURE_SHOW_ANNOUNCEMENT_BANNER: IJetFMFeature = {
  featureName: 'show_history_announcement_banner',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};

export const JETFM_ACTIVATE_FEEDBACK_CAMPAIGN: IJetFMFeature = {
  featureName: 'activate_campaign',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};

export const JETFM_ACTIVE_FEEDBACK_BUTTON: IJetFMFeature = {
  featureName: 'active_feedback_btn_path',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.String,
};

export const JETFM_CRT_COUNTDOWN_FLAG: IJetFMFeature = {
  featureName: 'show_crt_countdown',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};
export const JETFM_NEW_OVERVIEW_PAGE_SWITCH: IJetFMFeature = {
  featureName: 'show_new_overview_page',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
  valueUntilFMReady: null,
};

export const JETFM_ACTIVATE_FEEDBACK_SURVEY: IJetFMFeature = {
  featureName: 'activate_survey',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};

export const JETFM_SHOW_MANAGE_COURIERS: IJetFMFeature = {
  featureName: 'show_new_mc',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};

export const JETFM_TIPS_SHOW_BY_COUNTRY: IJetFMFeature = {
  featureName: 'show_tip_settings',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
  valueUntilFMReady: false,
};

export const JETFM_SHOW_NEW_DASHBOARD: IJetFMFeature = {
  featureName: 'show_new_dashboard',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};
export const JETFM_SHOW_TIPS: IJetFMFeature = {
  featureName: 'show_tips',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};

export const JETFM_ORDER_TOGGLE: IJetFMFeature = {
  featureName: 'show_order_toggle',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
};

export const JETFM_TIPS_RESTRICTED_COUNTRY_LIST: IJetFMFeature = {
  featureName: 'show_tip_settings_country_list',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.String,
  valueUntilFMReady: '',
};

export const JETFM_DASHBOARD_ALLOWED_COUNTRIES: IJetFMFeature = {
  featureName: 'dashboard_allowed_countries',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.String,
};

export const JETFM_MCP_VERSION_COMPARISON_VALUE: IJetFMFeature = {
  featureName: 'mcp_version_comparison_value',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.String,
  valueUntilFMReady: '',
};

export const JETFM_MCP_VERSION_REFRESHER_IS_ACTIVE_VALUE: IJetFMFeature = {
  featureName: 'mcp_version_refresher_is_active',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
  valueUntilFMReady: false,
};

export const JETFM_MCP_OCF_LANDING_PAGE_REDIRECTION: IJetFMFeature = {
  featureName: 'mcp_ocf_landing_page_redirection',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.Boolean,
  valueUntilFMReady: undefined,
};

export const JETFM_MCP_QR_CODE_USABLE_COUNTRY_LIST: IJetFMFeature = {
  featureName: 'mcp_qr_code_usable_country_list',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.String,
  valueUntilFMReady: undefined,
};

export const JETFM_MCP_OCF_ENABLED_COUNTRY_CODES: IJetFMFeature = {
  featureName: 'mcp_ocf_enabled_country_codes',
  featureDataType: JET_FM_FEATURE_DATA_TYPES.String,
  valueUntilFMReady: '',
};
